import React from 'react';
import { Image, StyleSheet, View } from 'react-native';

function LeadingIcon({ source, style }) {
  return (
    <View style={styles.container}>
      <Image source={source} style={style} />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    justifyContent: 'center',
    alignItems: 'center',
    paddingLeft: 15,
  },
});

export default LeadingIcon;
